import { render } from "./FooterView.vue?vue&type=template&id=2377d9ad"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=2377d9ad&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__